import { useModel } from '../model'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'
import useGlobalModel from '@/model/globalModel'
import { isOccupyOptions, isOccupyOptions1, isTfFlagOptions } from '@/types/TcoDs'

export function PageHeader() {
    const {
        user: { branch },
        whDs,
    } = useGlobalModel()
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = useModel()
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '商品编码',
            fieldName: 'materialCode',
            span: 4,
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: '商品名称',
            fieldName: 'materialName',
            span: 4,
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: '是否占用',
            fieldName: branch === 'scm' ? 'isOccupy' : 'occupy',
            span: 4,
            options: branch === 'scm' ? isOccupyOptions : isOccupyOptions1,
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: '仓库',
            fieldName: 'warehouseCode',
            span: 4,
            options: whDs,
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: '货位',
            fieldName: 'shelfCode',
            span: 4,
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: '是否投放',
            fieldName: 'tfFlag',
            span: 4,
            options: isTfFlagOptions,
        },
    ]

    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    )
}
